import axios from "axios"
const API_URL = process.env.REACT_APP_API_URL
const AuthKey = localStorage.getItem("accessToken")

const instance = axios.create({
  withCredentials: false,
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: AuthKey,
  },
})

export default instance
